/**
 * parecidoATarea — ¿lo que se escribe como tarea repite una que ya se genera sola? (18/10)
 *
 * Una baja genera por su cuenta la tarea de cada pieza que la persona tiene en Inventario y la de
 * cada acceso. Escribir a mano «Recuperar el portátil» la duplica: suma al total, y el cierre la
 * enumera como pendiente aunque el portátil ya esté devuelto. En el catálogo de tareas de baja es
 * peor: se copia en CADA baja nueva (pasó en TEST con «Devolución movil»).
 *
 * Esto sólo AVISA. No bloquea: puede ser legítimo («recuperar el portátil del almacén, no el suyo»).
 *
 * Se compara por PALABRAS, sin tildes y sin los verbos de siempre, y una palabra casa con otra si es
 * igual o una empieza por la otra (movil / moviles, portatil / portatiles).
 */

const VACIAS = new Set([
  'recuperar', 'recoger', 'devolver', 'devolucion', 'entregar', 'entrega', 'quitar', 'quitarle', 'revocar',
  'cancelar', 'liberar', 'acceso', 'accesos', 'tarea', 'tareas', 'material', 'licencia', 'cuenta', 'persona',
  'empresa', 'suyo', 'suya', 'para', 'desde', 'hacia', 'sobre', 'baja',
]);

export const norma = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();

export const palabras = (s) => norma(s).split(' ').filter((w) => w.length >= 4 && !VACIAS.has(w));

const casan = (a, b) => a === b || (Math.min(a.length, b.length) >= 4 && (a.startsWith(b) || b.startsWith(a)));

/**
 * @param texto       lo que se está escribiendo
 * @param candidatos  [{ etiqueta, textos: [string], donde }]
 * @returns los candidatos que se parecen, sin repetir etiqueta
 */
export function parecidos(texto, candidatos) {
  const ws = palabras(texto);
  if (!ws.length) return [];
  const vistos = new Set();
  return (candidatos || []).filter((c) => {
    if (vistos.has(c.etiqueta)) return false;
    const hay = (c.textos || []).some((t) => palabras(t).some((x) => ws.some((w) => casan(w, x))));
    if (hay) vistos.add(c.etiqueta);
    return hay;
  });
}
